import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/diaries/$diaryId/edit/tracker/$trackerId/schedule')({
    component: () => <div>Hello /_app/diary/$diaryId/tracker/$trackerId/edit/entry-times!</div>,
});
